export enum AppErrStatus {
  NotFound = "NotFound",
  Unauthorized = "Unauthorized",
  InvalidData = "InvalidData",
  InvalidOperation = "InvalidOperation",
  AlreadyExists = "AlreadyExists",
  GuardViolation = "GuardViolation",
  GenericDomain = "GenericDomain",
  Generic = "Generic",
}
